import { render, staticRenderFns } from "./ModalCadastraDisciplinaDireito.vue?vue&type=template&id=48216f01"
import script from "./ModalCadastraDisciplinaDireito.vue?vue&type=script&lang=js"
export * from "./ModalCadastraDisciplinaDireito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports